import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Header from '../components/header'
import FooterGray from '../components/footer-gray'
import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container1">
      <Helmet>
        <title>Contact - Better Call AI</title>
        <meta
          name="description"
          content="La solution de gestion des appels client par l'intelligence artificielle.\nPrise en charge de votre agenda et prise de rendez-vous automatique."
        />
        <meta property="og:title" content="Contact - Better Call AI" />
        <meta
          property="og:description"
          content="La solution de gestion des appels client par l'intelligence artificielle.\nPrise en charge de votre agenda et prise de rendez-vous automatique."
        />
      </Helmet>
      <Header></Header>
      <div className="contact-container2">
        <div className="contact-container3">
          <h1 className="contact-text1 HeadingOne">Prenons rendez-vous</h1>
          <p className="contact-text2 Lead">
            Nos collaborateurs seront ravis de vous rencontrer pour en savoir
            plus sur votre entreprise.
          </p>
          <div className="contact-container4">
            <div className="contact-container5">
              <Script
                html={`<!-- Calendly inline widget begin -->
<div class="calendly-inline-widget" data-url="https://calendly.com/better-call-ai/30min?hide_event_type_details=1&hide_gdpr_banner=1" style="min-width:320px;height:700px;"></div>
<script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
<!-- Calendly inline widget end -->`}
              ></Script>
            </div>
          </div>
        </div>
      </div>
      <FooterGray></FooterGray>
    </div>
  )
}

export default Contact
